import { IPublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";


export const getToken = async (msalInstance: IPublicClientApplication, scope: any) => {
  const init = await msalInstance.initialize();
  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts();

  if (!activeAccount && accounts.length === 0) {
    /*
    * User is not signed in. Throw error or wait for user to login.
    * Do not attempt to log a user in outside of the context of MsalProvider
    */
  }
  const request = {
    scopes: [(scope !== null || "") ? scope : process.env.REACT_APP_AZURE_CLIENTID + "/.default"],
    account: activeAccount || accounts[0]
  };


  try {
    const authResult = await msalInstance.acquireTokenSilent(request);
    return authResult.accessToken;
  } catch (error) {
    console.log("Silent token acquisition fails. Acquiring token using popup");
    if (error instanceof InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      return msalInstance.acquireTokenPopup(request)
        .then(tokenResponse => {
          console.log(tokenResponse);
          return tokenResponse.accessToken;
        }).catch(error => {
          console.error(error);
          return ""; // return an empty string instead of "null"
        });
    } else {
      console.error(error);
      return ""; // return an empty string instead of "null"
    }
  }
};